import * as refreshTokenActions from '../../src/store/refresh-token/actions'
import * as logOutActions from '../../src/store/logout/actions'
import {connect} from 'react-redux'
import RefreshTokenPanel from '../../src/components/refresh-token-panel'

function mapStateToProps (state) {
  return {
    isLoading: state.refreshToken.isLoading,
    authError: state.refreshToken.authError,
    isTokenRefreshed: state.refreshToken.isTokenRefreshed,
  }
}

export default connect(mapStateToProps, {...refreshTokenActions, ...logOutActions})(RefreshTokenPanel)



// WEBPACK FOOTER //
// ./src/containers/refresh-token-panel-container.js